module.exports = __webpack_public_path__ + "media/images/common/ico-lp-about-soup-3abbb82daec8376c3ef4968c0056e6ef.svg";